const exerciseHours = ["1-2", "3-4", "5-6", "7 o más"];
export default exerciseHours;
